export default class OrderForm {
  constructor(form) {
    this.form = form;
    this.data = {};
    this.product = {};
  }

  init() {
    this.form.addEventListener('input', (event) => {
      this.handleFormChange(event);
    });

    this.handleFormChange();
  }

  handleFormChange(event) {
    const elements = this.form.elements;
    for (let element of elements) {
      if (element.id) {
       this.data[element.id] = element.value
      }
    }
    console.log(this.data);
    setTimeout(() => {
      this.setProduct();
      console.log (this.product)
    }, 200);
    this.updateInterface();
  }

  updateInterface() {
    console.log('updateing interface')
  
  }

  setProduct() {
    const teasers = Array.from(this.selectVisibleTeaser());

    for (let teaser of teasers) {
      this.product.member = teaser.querySelector(this.getMemberSelector());
      this.product.abo = teaser.querySelector('.abo-price');
      this.product.service = teaser.querySelector('.service-price')
    }
  }

  getMemberSelector() {
    return this.isMember() ? '.member-price' : '.standard-price'
  }

  selectVisibleTeaser() {
    return document.querySelectorAll('.formbuilder-row:not(.is-hidden) .js-teaser-product')
  }

  isMember() {
    return this.data['formbuilder_1_membership'] == 'Ja' || this.data['formbuilder_1_NoMember_0_field_11458'] == 'Ja';
  }
}
